<template>
  <div class="wrapper">
    <router-view></router-view>
    <tabbar></tabbar>
  </div>
</template>

<script>
import Tabbar from './components/Tabbar'
export default {
  name: 'Layout',
  components: { Tabbar },
}
</script>
